<template>
  <VaLayout
    v-if="breakpoint.lgUp"
    class="h-screen bg-[var(--va-background-secondary)]"
  >
    <template #left>
      <RouterLink
        class="bg-primary h-full flex items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <img
          src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=456,fit=crop,q=95/mjE9yDLVLOsVaPL1/hindustan-AR0b9zE0GzsDDOpJ.png"
        />
      </RouterLink>
    </template>
    <template #content>
      <main
        class="h-full flex items-center justify-center mx-auto max-w-[420px]"
      >
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main
          class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]"
        >
          <div class="flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <img
                class="mb-2"
                start="#0E41C9"
                src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=456,fit=crop,q=95/mjE9yDLVLOsVaPL1/hindustan-AR0b9zE0GzsDDOpJ.png"
              />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useBreakpoint } from "vuestic-ui";
import VuesticLogo from "../components/VuesticLogo.vue";
import { userService } from "../services/user_api_services";

const breakpoint = useBreakpoint();
const { push } = useRouter();

if (localStorage.getItem("accessToken")) {
  console.log("Auth - 1");
  userService
    .validateToken()
    .then((response) => {
      push({ name: "profile" });
    })
    .catch((error) => {
      console.log("Auth - 11");
      console.log(error.response);
    });
} else {
  console.log("Auth - 2");
  push({ name: "login" });
}
</script>
